<template>
  <div class="bind-account">
    <div class="register-cont">
      <t-message v-show="isToastshow" theme="error" icon :duration="2000" :content="message" />
      <h1>绑定账号</h1>
      <div class="tab-check">
        <p :class="[istabCheck == 1 ? 'p1' : 'p2']" @click="changeTab(1)">
          新账号
        </p>
        <p :class="[istabCheck == 2 ? 'p1' : 'p2']" @click="changeTab(2)">
          已有账号
        </p>
      </div>
      <newAccount v-if="registerType == '1'" @setRegisterType="setRegisterType" @setOldPhone="setOldPhone"
        :referUrl="referUrl" />

      <oldAccount v-else :referUrl="referUrl" :codeLogin="codeLogin" :oldPhone="oldPhone"
        @setRegisterType="setRegisterType" />
    </div>
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog" @success="onSuccess" @again="onAgain" />
  </div>
</template>

<script>
import { zhugeTrack, getQueryString } from "@/utils/utils";
import newAccount from "@/components/Bind-account/new-account";
import oldAccount from "@/components/Bind-account/old-account";
import sliderVerify from "@/components/common/puzzleVerify";
import { mapState, mapMutations } from "vuex";
export default {
  name: "bindAccount",
  components: {
    newAccount,
    oldAccount,
    sliderVerify
  },
  data() {
    return {
      codeLogin: false,
      istabCheck: 1,
      oldPhone: '',
      registerType: "1",
      referUrl: "", // 登录后跳转的页面 （url携带）
    };
  },
  computed: {
    ...mapState(["isToastshow", "message", "isShowSliderVerify"]),
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");
    // 更换不同主题色
    zhugeTrack("进入_注册页",{
      终端:"Web"
    });
  },
  methods: {
    onSuccess() {},
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() {},
    setOldPhone(val) {
      this.oldPhone = val
    },
    changeTab(value) {
      this.istabCheck = value;

      if (this.registerType == 2 && value == 1) {
        this.oldPhone = ""//切换tab清空已有账号手机号
      }
      this.registerType = value;

    },
    setRegisterType(type) {
      this.registerType = type;
    },
  },
  metaInfo() {
    return {
      title: window.location.search.indexOf('match')>-1?'用户注册 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛':'用户注册 - 博学谷·黑马程序员线上品牌',
      meta: [
        {
          name: "keyWords",
          content: "新用户,注册入口,注册,网址,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷官网注册入口，学员可以注册学习账号，选择自己喜欢的IT课程或视频教程，在线学习学习Java、Python、云计算大数据、前端开发、UI设计、人工智能、软件测试与移动开发、PHP、电商运营等视频课程。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: window.location.search.indexOf('match')>-1?'/favicon.czb.ico':'/favicon.ico' }]
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .register-cont {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .register-cont {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .register-cont {
    right: 200px !important;
  }
}

.bind-account {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    width: max-content;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .toast {
    z-index: 999;
    position: absolute;
    top: 40%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 26px;
    padding: 30px 71px;
    text-align: center;
    white-space: nowrap;
  }

  .register-cont {
    width: 464px;
    height: 520px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;

    h1 {
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 32px;
      margin: 48px auto 24px;
      text-align: center;
    }

    .tab-check {
      display: flex;
      margin-left: 48px;
    }

    .p1 {
      height: 24px;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #165dff;
      cursor: pointer;

      &::after {
        content: "";
        width: auto;
        height: 3px;
        background: #165dff;
        border-radius: 4px 4px 0px 0px;
        display: block;
        margin-top: 7px;
      }
    }

    .p2 {
      height: 24px;

      cursor: pointer;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #4e5969;

      &:hover {
        color: #165dff;
      }
    }
  }

  ::v-deep .user-register {
    p {
      span {
        color: #165dff !important;

        &:hover {
          color: #4080ff !important;
        }
      }
    }

    .get-code {
      color: #4e5969 !important;

      &:hover {
        color: #4080ff !important;
      }
    }
  }

  ::v-deep .el-form-item__content {
    line-height: normal;
  }

  ::v-deep .register-from {
    margin-top: 33px;

    .el-form-item {
      margin-bottom: 24px;
    }

    .el-input__inner {
      width: 368px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      line-height: 40px;

      padding-left: 16px;
      box-sizing: border-box;
      border: 1px solid #e5e6eb;

      &:focus {
        border: 1px solid #165dff;
      }
    }

    .is-error {
      .el-input__inner {
        border: 1px solid #f53f3f;
      }

      .el-form-item__error {
        padding-top: 0px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f53f3f;
        line-height: 20px;
      }
    }
  }

  ::v-deep .btn {
    background: #165dff;

    &:hover {
      background: #4080ff;
    }
  }

  ::v-deep .other-login {
    span {
      color: #165dff;

      &:hover {
        color: #4080ff !important;
      }
    }
  }
}</style>
